import React, {useState} from 'react';

import { useHistory } from 'react-router-dom';
import { SideSpacer } from '../../components/common/Spacer';
import HeaderContainer from '../../containers/common/HeaderContainer';
import Navigation from '../../components/common/Navigation';
import {
  CommonContainer,
  HistoryBlock,
  NormalHistory,
  HistoryBtn
} from '../../components/common/Container';
import AppMainContainer from '../../containers/app/AppMainContainer';
import { RiArrowLeftSLine } from 'react-icons/ri';
import AutoMessageContainer from '../../containers/app/AutoMessageContainer';

const AutoMessagePage = () => {
  const user = JSON.parse(localStorage.getItem('user'))
  let history = useHistory();

  const onClickBackButton = () => {
    history.goBack()
  }

  if (!user) {
    alert('잘못된 접근입니다 다시 로그인 해 주세요');
    history.push('/');
    return false;
  }
  
  return (
    <>
      <HeaderContainer />
      <Navigation />
      <SideSpacer>
        <CommonContainer style={{minWidth: '1450px'}}>
            <HistoryBlock>
              <HistoryBtn style={{marginBottom: '15px'}}><RiArrowLeftSLine onClick={() => onClickBackButton()}/></HistoryBtn>
              <NormalHistory style={{fontWeight: 'bold', marginBottom: '15px'}} >
                자동 알림 편집
              </NormalHistory>
            </HistoryBlock>
            <AutoMessageContainer history={history}/>
        </CommonContainer>
      </SideSpacer>
    </>
  );
};

export default AutoMessagePage;
